import React from 'react';
import { Lock } from 'lucide-react';
export function TrustBadges() {
  return <div className="max-w-[420px] mx-auto my-5 px-6" data-id="element-45">
      {/* Pago Seguro Section */}
      <fieldset className="border border-[#c8c8c8] rounded-xl p-3 px-5 text-center mb-6 bg-transparent relative" data-id="element-46">
        <legend className="px-2.5 text-[#666] text-sm flex items-center gap-1.5 mx-auto bg-cream" data-id="element-47">
          <Lock size={14} strokeWidth={2} data-id="element-48" />
          Pago seguro garantizado
        </legend>
        <div className="flex justify-center gap-5 items-center pt-1" data-id="element-49">
          <div className="text-[#1434CB] font-black italic text-2xl tracking-tight" style={{
          fontFamily: 'Arial, sans-serif'
        }} data-id="element-50">
            VISA
          </div>

          <div className="flex flex-col items-center" data-id="element-51">
            <svg viewBox="0 0 32 20" width="32" height="20" data-id="element-52">
              <circle cx="11" cy="10" r="10" fill="#EB001B" data-id="element-53" />
              <circle cx="21" cy="10" r="10" fill="#F79E1B" opacity="0.9" data-id="element-54" />
            </svg>
            <span className="text-[8px] text-[#333] mt-0.5" data-id="element-55">Mastercard</span>
          </div>

          <div className="text-2xl" style={{
          fontFamily: 'Arial, sans-serif'
        }} data-id="element-56">
            <span className="text-[#003087] font-bold" data-id="element-57">Pay</span>
            <span className="text-[#009cde] font-bold" data-id="element-58">Pal</span>
          </div>
        </div>
      </fieldset>

      {/* MercadoLíder Section */}
      <div className="bg-white rounded-xl p-5 shadow-sm border border-[#eaeaea]" data-id="element-59">
        <div className="flex items-start gap-3 mb-4" data-id="element-60">
          <div className="flex items-center justify-center mt-0.5" data-id="element-61">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" data-id="element-62">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#00a650" stroke="#00a650" strokeWidth="1" data-id="element-63" />
            </svg>
          </div>
          <div className="flex-1" data-id="element-64">
            <h3 className="text-[#00a650] text-xl font-bold leading-tight tracking-tight m-0" data-id="element-65">
              MercadoLíder
            </h3>
            <p className="text-[#8c8c8c] text-[15px] m-0 mt-1" data-id="element-66">
              Uno de los mejores del sitio
            </p>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="flex h-1.5 gap-1 mb-5" data-id="element-67">
          <div className="flex-1 rounded-full bg-[#fce6e6]" data-id="element-68"></div>
          <div className="flex-1 rounded-full bg-[#ffecd4]" data-id="element-69"></div>
          <div className="flex-1 rounded-full bg-[#fff8cc]" data-id="element-70"></div>
          <div className="flex-1 rounded-full bg-[#e6f9e6]" data-id="element-71"></div>
          <div className="flex-1 rounded-full bg-[#39b54a]" data-id="element-72"></div>
        </div>

        {/* Stats */}
        <div className="flex justify-between text-center" data-id="element-73">
          <div className="flex flex-col items-center flex-1 text-[13px] text-[#8c8c8c]" data-id="element-74">
            <div className="h-6 flex items-center mb-1" data-id="element-75">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8c8c8c" strokeWidth="2" data-id="element-76">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" data-id="element-77" />
                <circle cx="12" cy="7" r="4" data-id="element-78" />
              </svg>
            </div>
            <strong className="text-[#333] text-[17px] font-bold mb-1 leading-tight" data-id="element-79">
              +500
            </strong>
            <span data-id="element-80">Ventas</span>
          </div>
          <div className="flex flex-col items-center flex-1 text-[13px] text-[#8c8c8c]" data-id="element-81">
            <div className="h-6 flex items-center mb-1" data-id="element-82">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8c8c8c" strokeWidth="2" data-id="element-83">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-84" />
              </svg>
            </div>
            <strong className="text-[#333] text-[17px] font-bold mb-1 leading-tight" data-id="element-85">
              4.9
            </strong>
            <span data-id="element-86">Calificación</span>
          </div>
          <div className="flex flex-col items-center flex-1 text-[13px] text-[#8c8c8c]" data-id="element-87">
            <div className="h-6 flex items-center mb-1" data-id="element-88">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8c8c8c" strokeWidth="2" data-id="element-89">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" data-id="element-90" />
                <polyline points="22 4 12 14.01 9 11.01" data-id="element-91" />
              </svg>
            </div>
            <strong className="text-[#333] text-[17px] font-bold mb-1 leading-tight" data-id="element-92">
              100%
            </strong>
            <span data-id="element-93">Positivas</span>
          </div>
        </div>
      </div>
    </div>;
}